import { observer } from 'mobx-react';
import { FC } from 'react';
import takerGoStore from '../../store/takerGoStore';
import { localeStore } from '~/mobx/localesStore';
import { MaskedInput } from '~/view/components/Controls/Inputs';
import Text from '~/view/components/Text/Text';

const YallowApiKey: FC = observer((): JSX.Element => {
  const handleValueChange = (value: string | undefined) => {
    takerGoStore.changeSettings({ yallowApiKey: value });

    if (takerGoStore.validationErrors?.yallowApiKey) {
      takerGoStore.changeValidationErrors({ yallowApiKey: undefined });
    }
  };

  return (
    <div className="d-flex align-items-center">
      <Text type="order-field" text="yallow_api_key" className="integration-settings__field w-40" />

      <MaskedInput
        value={takerGoStore.settings.yallowApiKey}
        onChangeValue={handleValueChange}
        validation={{ isValid: takerGoStore.validationErrors?.yallowApiKey == null, errorText: takerGoStore.validationErrors?.yallowApiKey }}
        placeholder={localeStore.t('Value')}
        className="flex-1"
        contentClassName="full-width"
      />
    </div>
  );
});

export default YallowApiKey;
